import React from 'react'
import {ThreeColumn} from '@/components/hero'
import {IthreeColumnProps} from '@/components/hero/types'
export const ThreeColumnHero = (props: IthreeColumnProps) => {
    return <ThreeColumn {...props} />
}

export const ThreeColumnHeroDefinition = {
    component: ThreeColumnHero,
    name: 'HeroThreeColumn',
    noWrap: true,
    inputs: [
        {
            name: 'backgroundType',
            type: 'string',
            enum: ['color', 'image', 'carousel', 'gradient'],
            defaultValue: 'color',
            required: false
        },
        {
            name: 'backgroundGradient',
            type: 'gradientCreator',
            defaultValue: 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)',
            showPreview: true,
            showIf: `options.get('backgroundType') === 'gradient' && options.get('backgroundType') !== 'carousel'`,
            showCssOutput: true
        },
        {
            name: 'carouselDots',
            type: 'boolean',
            required: false,
            defaultValue: false,
            label: 'Show Dots for Carousel',
            showIf: `options.get('backgroundType') === 'carousel'`
        },
        {
            name: 'carouselAutoplay',
            type: 'boolean',
            required: false,
            defaultValue: false,
            label: 'Enable Autoplay for Carousel',
            showIf: `options.get('backgroundType') === 'carousel'`
        },
        {
            name: 'carouselAutoplayDelay',
            type: 'number',
            required: false,
            defaultValue: 4000,
            label: 'Autoplay Delay (ms)',
            showIf: `options.get('backgroundType') === 'carousel'`
        },
        {
            name: 'carouselItems',
            type: 'list',
            showIf: `options.get('backgroundType') === 'carousel'`,
            label: 'Carousel Items',
            required: false,
            subFields: [
                {
                    name: 'carouselBackgroundType',
                    type: 'string',
                    enum: ['color', 'image', 'gradient'],
                    defaultValue: 'image',
                    required: false
                },
                {
                    name: 'backgroundGradient',
                    type: 'gradientCreator',
                    defaultValue: 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)',
                    showPreview: true,
                    showIf: `options.get('carouselBackgroundType') === 'gradient'`,
                    showCssOutput: true
                },
                {
                    name: 'backgroundImage',
                    type: 'file',
                    showIf: `options.get('carouselBackgroundType') === 'image'`,
                    required: false
                },
                {
                    name: 'backgroundImageMobile',
                    type: 'file',
                    showIf: `options.get('carouselBackgroundType') === 'image'`,
                    required: false
                },
                {
                    name: 'backgroundColor',
                    type: 'color',
                    required: false,
                    defaultValue: '#FFFFFF'
                },
                {
                    name: 'leftImage',
                    type: 'file',
                    required: false
                },
                {
                    name: 'rightImage',
                    type: 'file',
                    required: false
                },
                {
                    name: 'mobileImageLeft',
                    type: 'file',
                    required: false
                },
                {
                    name: 'mobileImageRight',
                    type: 'file',
                    required: false
                },
                {
                    name: 'textAlignment',
                    type: 'string',
                    enum: ['left', 'center', 'right'],
                    defaultValue: 'center',
                    required: false
                },
                {
                    name: 'eyebrowType',
                    type: 'string',
                    enum: ['none', 'icon', 'pill', 'text', 'rounded', 'square'],
                    defaultValue: 'pill'
                },
                {
                    name: 'eyebrowSize',
                    type: 'string',
                    enum: ['small', 'large'],
                    defaultValue: 'large',
                    required: false,
                    showIf: `options.get('eyebrowType') !== 'none'`
                },
                {
                    name: 'eyebrowBackgroundColor',
                    type: 'color',
                    required: false,
                    defaultValue: '#E0E0E0',
                    showIf: `options.get('eyebrowType') !== 'none' && options.get('eyebrowType') !== 'icon'`
                },
                {
                    name: 'eyebrowTextColor',
                    type: 'color',
                    required: false,
                    defaultValue: '#000000',
                    showIf: `options.get('eyebrowType') !== 'none'`
                },
                {
                    name: 'eyebrowIcon',
                    type: 'file',
                    required: false,
                    showIf: `options.get('eyebrowType') === 'icon'`
                },
                {
                    name: 'eyebrowText',
                    type: 'richText',
                    required: false,
                    showIf: `options.get('eyebrowType') !== 'none'`,
                    defaultValue: 'New Arrival'
                },
                {
                    name: 'headlineType',
                    type: 'string',
                    enum: ['image', 'text'],
                    defaultValue: 'text',
                    required: false
                },
                {
                    name: 'headlineImage',
                    type: 'file',
                    required: false,
                    showIf: `options.get('headlineType') === 'image'`
                },
                {
                    name: 'headlineText',
                    type: 'richText',
                    required: false,
                    showIf: `options.get('headlineType') === 'text'`,
                    defaultValue: '<p>Discover Our Latest Collection</p>'
                },
                {
                    name: 'textBlock',
                    type: 'richText',
                    required: false,
                    defaultValue:
                        '<p>Explore our new arrivals and find the perfect outfit to express your unique style. From casual wear to formal attire, we have something for everyone.</p>'
                },
                {
                    name: 'disclaimerText',
                    type: 'richText',
                    required: false,
                    defaultValue: '<p>*Free shipping on orders over $50</p>'
                },
                {
                    name: 'enableCouponCode',
                    type: 'boolean',
                    required: false,
                    defaultValue: false
                },
                {
                    name: 'couponCode',
                    type: 'string',
                    required: false,
                    showIf: `options.get('enableCouponCode') === true`,
                    defaultValue: 'SUMMER16'
                },
                {
                    name: 'callToAction',
                    type: 'string',
                    required: false,
                    defaultValue: 'Shop Now'
                },
                {
                    name: 'buttonColor',
                    type: 'color',
                    required: false,
                    defaultValue: 'color-core-blue-900'
                },
                {
                    name: 'external',
                    type: 'boolean',
                    required: false,
                    label: 'is the link external?'
                },
                {
                    name: 'external_link',
                    type: 'reference',
                    model: 'external-links',
                    required: false,
                    showIf: `options.get('external') === true`,
                    label: 'External Link URL',
                    defaultValue: 'https://www.example.com'
                },
                {
                    name: 'link',
                    type: 'reference',
                    model: 'page',
                    showIf: `options.get('external') !== true`,
                    required: false,
                    defaultValue: '#'
                },
                {
                    name: 'enableOverlay',
                    type: 'boolean',
                    required: false,
                    defaultValue: false
                },
                {
                    name: 'overlayColor',
                    type: 'color',
                    required: false,
                    defaultValue: '#000000',
                    showIf: `options.get('enableOverlay') === true`
                }
            ]
        },
        {
            name: 'backgroundImage',
            type: 'file',
            showIf: `options.get('backgroundType') === 'image' && options.get('backgroundType') !== 'carousel' && options.get('backgroundType') !== 'gradient'`,
            required: false
        },
        {
            name: 'backgroundImageMobile',
            type: 'file',
            showIf: `options.get('backgroundType') === 'image' && options.get('backgroundType') !== 'carousel' && options.get('backgroundType') !== 'gradient'`,
            required: false
        },
        {
            name: 'backgroundColor',
            type: 'color',
            required: false,
            defaultValue: '#FFFFFF',
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'leftImage',
            type: 'file',
            required: false,
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'rightImage',
            type: 'file',
            required: false,
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'mobileImageLeft',
            type: 'file',
            required: false,
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'mobileImageRight',
            type: 'file',
            required: false,
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'textAlignment',
            type: 'string',
            enum: ['left', 'center', 'right'],
            defaultValue: 'center',
            required: false,
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'callToAction',
            type: 'string',
            required: false,
            defaultValue: 'Shop Now',
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'buttonColor',
            type: 'color',
            required: false,
            defaultValue: 'color-core-blue-900',
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'external',
            type: 'boolean',
            required: false,
            label: 'is the link external?',
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'external_link',
            type: 'reference',
            model: 'external-links',
            required: false,
            showIf: `options.get('external') === true && options.get('backgroundType') !== 'carousel'`,
            label: 'External Link URL',
            defaultValue: 'https://www.example.com'
        },
        {
            name: 'link',
            type: 'reference',
            model: 'page',
            showIf: `options.get('external') !== true && options.get('backgroundType') !== 'carousel'`,
            required: false,
            defaultValue: '#'
        },
        {
            name: 'headlineType',
            type: 'string',
            enum: ['image', 'text'],
            defaultValue: 'text',
            required: false,
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'headlineImage',
            type: 'file',
            required: false,
            showIf: `options.get('headlineType') === 'image' && options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'headlineText',
            type: 'richText',
            required: false,
            showIf: `options.get('headlineType') === 'text' && options.get('backgroundType') !== 'carousel'`,
            defaultValue: '<p>Discover Our Latest Collection</p>'
        },

        {
            name: 'textBlock',
            type: 'richText',
            required: false,
            defaultValue:
                '<p>Explore our new arrivals and find the perfect outfit to express your unique style. From casual wear to formal attire, we have something for everyone.</p>',
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'eyebrowType',
            type: 'string',
            enum: ['none', 'icon', 'pill', 'text', 'rounded', 'square'],
            defaultValue: 'pill',
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'eyebrowSize',
            type: 'string',
            enum: ['small', 'large'],
            defaultValue: 'large',
            required: false,
            showIf: `options.get('eyebrowType') !== 'none' && options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'eyebrowBackgroundColor',
            type: 'color',
            required: false,
            defaultValue: '#E0E0E0',
            showIf: `options.get('eyebrowType') !== 'none' && options.get('eyebrowType') !== 'icon' && options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'eyebrowTextColor',
            type: 'color',
            required: false,
            defaultValue: '#000000',
            showIf: `options.get('eyebrowType') !== 'none' && options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'eyebrowIcon',
            type: 'file',
            required: false,
            showIf: `options.get('eyebrowType') === 'icon' && options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'eyebrowText',
            type: 'richText',
            required: false,
            showIf: `options.get('eyebrowType') !== 'none' && options.get('backgroundType') !== 'carousel'`,
            defaultValue: 'New Arrival'
        },
        {
            name: 'disclaimerText',
            type: 'richText',
            required: false,
            defaultValue: '<p>*Free shipping on orders over $50</p>',
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'enableCouponCode',
            type: 'boolean',
            required: false,
            defaultValue: false,
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'couponCode',
            type: 'string',
            required: false,
            showIf: `options.get('enableCouponCode') === true && options.get('backgroundType') !== 'carousel'`,
            defaultValue: 'SUMMER16'
        },
        {
            name: 'enableOverlay',
            type: 'boolean',
            required: false,
            defaultValue: false,
            showIf: `options.get('backgroundType') !== 'carousel'`
        },
        {
            name: 'overlayColor',
            type: 'color',
            required: false,
            defaultValue: '#000000',
            showIf: `options.get('enableOverlay') === true && options.get('backgroundType') !== 'carousel'`
        }
    ]
}
